import { SxProps, Theme } from '@mui/material';

/**
 * Не даёт потребителю через `sx` уронить containing block позиционированной
 * кнопки-оверлея.
 *
 * MUI рисует ripple в `.MuiTouchRipple-root` (`position: absolute; inset: 0`,
 * `overflow: hidden`) — он позиционируется от БЛИЖАЙШЕГО позиционированного
 * предка. Пара кнопок «сердце» (`FavoriteHeartButton`) и «в папку»
 * (`BookmarkFolderButton`) живёт то оверлеем на фото карточки, то обычным
 * элементом в потоке — и часть потребителей (профиль актёра, окно быстрого
 * просмотра, строка таблицы избранного, строка/плитка/лента фото карточки)
 * ставят кнопке `position: 'static'`, чтобы вернуть её из абсолютного
 * позиционирования в обычный поток. Это снимает с кнопки containing block:
 * ripple вместо круга внутри кнопки растекается бледным пятном на ближайшего
 * позиционированного предка (карточку/строку/всю таблицу), перекрывая соседние
 * элементы (дефект 18997).
 *
 * `position: 'relative'` даёт ТУ ЖЕ раскладку, что и `'static'` (пока нет
 * `top`/`left`/`right`/`bottom` со значением), но остаётся containing block —
 * поэтому любой `'static'`, переданный потребителем, здесь принудительно
 * заменяется на `'relative'`. Работает, пока `sx` потребителя — обычный
 * объект (так и есть у всех нынешних потребителей обеих кнопок — их `sx`
 * подмешивается в стили компонента через `...sx`); `sx`-массив или
 * `sx`-функция от темы этим guard'ом не перехватываются.
 * @param sx - `sx`, переданный потребителем кнопки
 */
export const guardContainingBlockSx = (
  sx: SxProps<Theme> | undefined
): SxProps<Theme> | undefined => {
  if (
    sx &&
    typeof sx === 'object' &&
    !Array.isArray(sx) &&
    (sx as { position?: unknown }).position === 'static'
  ) {
    return { ...sx, position: 'relative' };
  }
  return sx;
};
